module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/_path.js
// module id = 289
// module chunks = 0